import { render } from "./TravelSausageBadge.vue?vue&type=template&id=5cf222a2"
import script from "./TravelSausageBadge.vue?vue&type=script&lang=js"
export * from "./TravelSausageBadge.vue?vue&type=script&lang=js"

import "./TravelSausageBadge.vue?vue&type=style&index=0&id=5cf222a2&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__